import { render, staticRenderFns } from "./LoadingListPlaceholder.vue?vue&type=template&id=2236365f&scoped=true"
import script from "./LoadingListPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingListPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LoadingListPlaceholder.vue?vue&type=style&index=0&id=2236365f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236365f",
  null
  
)

export default component.exports